import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import * as actions from '../../store/actions/actions'
import {Button, Card, CardBody, Form, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText} from "reactstrap";
import {Translate} from "react-localize-redux";
import { withLocalize } from "react-localize-redux";

import italianPasswordRecoverTranslations from "../../translations/password/recover/it.password.recover.json";
import englishPasswordRecoverTranslations from "../../translations/password/recover/en.password.recover.json";

class Recover extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianPasswordRecoverTranslations, "it");
    this.props.addTranslationForLanguage(englishPasswordRecoverTranslations, "en");
  }

  submitHandler = (event) => {
    event.preventDefault();
    let username = event.target.username.value;
    let email = event.target.email.value;
    let bank = localStorage.getItem('bank')
    const data = {username, email, bank};
    this.props.recover(data)
  }

  render() {

    let errors="";
    let hasError=false
    errors=this.props.validationError;
    let errorMessage=""
    let defaultErrorMessage=""
    if(errors !== null && errors !== "" && errors !== undefined){
      if(Array.isArray(errors.data))
        defaultErrorMessage = errors.data[0].defaultMessage
      else
        defaultErrorMessage = errors.data.message
      if(errors.status === 401){
        errorMessage=<Translate id={defaultErrorMessage}/>
      }else if(errors.status === 403) {
        errorMessage = <Translate id={defaultErrorMessage}/>
      }else if(errors.status === 400) {
        errorMessage = <Translate id={defaultErrorMessage}/>
      } else if(errors.status === 500){
        errorMessage=<Translate id={defaultErrorMessage}/>
      }else if(errors.status === 404){
        errorMessage=<Translate id="recover.connection" data={{ statusText : errors.statusText }}/>
      }
      hasError=true
    }

    let bankFromUrl = this.props.history.location.pathname.split("/")[1];
    let bankDefault = 'plick'
    let bank = (bankFromUrl !== undefined || bankFromUrl !== '' || bankFromUrl !== null) ? bankFromUrl : bankDefault;
    localStorage.setItem('bank', bank);

    return (
        <>
          <Col lg="5" md="7" className="mt--9">
            <Card className="bg-secondary shadow border-0">
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <small>
                    <Translate id="password.recover.title"/>
                  </small>
                </div>
                <div className={hasError === true ? "text-center text-muted mb-4" : "noErrors"}>
                  <small className={hasError === true ? "highlight":""}>{errorMessage}</small>
                </div>
                <Form role="form" onSubmit={this.submitHandler}>
                  <FormGroup className="mb-3">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-single-02" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Translate>
                        {({ translate }) =>
                          <Input id="username"
                             label={translate("password.recover.username")}
                             placeholder={translate("password.recover.username")}
                             type="text"
                             autoComplete="new-email"/>}
                      </Translate>
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-email-83" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Translate>
                        {({ translate }) =>
                          <Input id="email"
                             label={translate("password.recover.email")}
                             placeholder={translate("password.recover.email")}
                             type="text"
                             autoComplete="new-email"/>}
                      </Translate>
                    </InputGroup>
                  </FormGroup>
                  <div className="text-center">
                    <Button className="my-4" type="submit" variant="contained" color="primary">
                      <Translate id="password.recover.button"/>
                    </Button>
                  </div>
                </Form>
              </CardBody>

            </Card>
          </Col>
        </>
    );
  }
}

const mapStateToProps = state => {
  return {
    validationError:state.password.error,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    recover: (data) => dispatch({ type: actions.RECOVER_PASSWORD_REQUEST, value: data })
  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Recover));